﻿<template>
    <b-container class="product-filter" v-if="filters && filters.length">
        <b-card class="pb-2 pt-0 border-0" no-body>
            <div v-if="!isMobile" class="fw-bold fs-5">{{ $t('filter') }}</div>
            <b-button class="w-100 mt-2 mb-4 clear-button"
                      pill
                      variant="outline-secondary"
                      @click="clearFilters">
                {{ $t('clearFilters') }}
            </b-button>
            <b-accordion free>
                <b-accordion-item v-for="(filter, index) in filters"
                                  :key="index"
                                  :title="filter.name"
                                  class="border-top border-2 mt-0 fw-semibold">
                    <div v-for="(value, subIndex) in filter.values" :key="`sub_${subIndex}`">
                        <b-form-checkbox v-if="value.products_count > 0"
                                         v-model="selectedFilters"
                                         :value="value.id"
                                         @change="sendSelectedFilters">
                            {{ value.name }}
                        </b-form-checkbox>
                    </div>
                </b-accordion-item>
            </b-accordion>
        </b-card>
    </b-container>
</template>

<script>
    import { CustomerConstant } from "@/constants/customer-constant";
    import { MediaPointConstant } from '@/constants/mediaPoint-constants';

    export default {
        data() {
            return {
                selectedFilters: []
            }
        },

        props: {
            pageFilter: {
                type: Object
            }
        },

        computed: {
            filters() {
                //Init filters
                let filters = this.pageFilter ? this.pageFilter.specification_filter.attributes : [];

                //Custom sorting. Be careful! we don`t use display order property here
                let sortingArr = [
                    CustomerConstant.nominalVoltageId,
                    CustomerConstant.maxFuseId,
                    CustomerConstant.numberOfPositionId,
                    CustomerConstant.numberOfBusesId,
                    CustomerConstant.busRatingId,
                    CustomerConstant.inputTypeId,
                    CustomerConstant.outputTypeId,
                    CustomerConstant.rackSpacesId,
                    CustomerConstant.mountingId
                ];

                //Sorting
                filters.sort((a, b) => sortingArr.indexOf(a.id) - sortingArr.indexOf(b.id));

                return filters;
            },

            isMobile() {
                return window.innerWidth <= MediaPointConstant.MediaPointMd;
            }
        },

        methods: {
            sendSelectedFilters() {
                this.$emit('sendSelectedFilters', this.selectedFilters);
            },

            clearFilters() {
                this.selectedFilters = [];
                this.$emit('sendSelectedFilters');
            }
        },

        watch: {
            "$route.path"() {
                this.selectedFilters = [];
            }
        },
    }
</script>